'use client';

import { useReportWebVitals } from 'next/web-vitals';
import { capture } from './client';
import { isPostHogEnabled } from './config';
import type { PostHogEventMap } from './events';

type WebVitalMetric = PostHogEventMap['web_vital']['metric'];
const REPORTED_METRICS = new Set<string>(['CLS', 'FCP', 'INP', 'LCP', 'TTFB']);

/**
 * Reports Core Web Vitals to PostHog as one `web_vital` event per metric.
 *
 * Lab numbers (curl, DevTools traces) only describe one machine on one
 * network; this is the field view — what visitors actually get — and it is
 * the yardstick every performance change is judged by. A no-op until the
 * PostHog project key is configured, like the rest of the scaffold.
 */
export function PostHogWebVitals() {
  useReportWebVitals((metric) => {
    if (!isPostHogEnabled() || !REPORTED_METRICS.has(metric.name)) return;
    capture('web_vital', {
      metric: metric.name as WebVitalMetric,
      value: metric.value,
      delta: metric.delta,
      rating: metric.rating,
      metric_id: metric.id,
      navigation_type: metric.navigationType,
      // The pathname, not the full URL: it lets the dashboard group by route
      // without every query string or slug becoming its own bucket.
      route: window.location.pathname,
    });
  });

  return null;
}
